import {
    CaseFileStaticItems,
    FavoriteTypesEnum,
    TutorialTopics,
    UserRightsEnum,
} from '../../../utilities/Constants';

import Authorization from '../../../stores/Authorization';
import CaseHelper from '../../../utilities/CaseHelper';
import { CaseName } from '../CaseName';
import { Favorite } from '../../shared/Favorite';
import { ICaseModel } from '../../../interfaces/ICase';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { Link } from 'react-router-dom';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useZoneContext } from '../../../contexts/useZoneContext';

export interface ICaseEasyUpdateHeaderProps {
    additionalHeaderText?: string;
    addNewCase: boolean;
    changesDetected: boolean;
    currentCase?: ICaseModel;
    easyUpdateFieldsSelected?: IMultiSelectOption[];
    onAddNewCase: () => void;
    onBack: () => void;
    onCancel: ((hadChanges: boolean) => void) | undefined;
    onClear: () => void;
    onSaveCase: () => void;

    currentFavoriteDetailsString: string;
    onFavoriteSelected: (settingJson?: string) => void;
    onApplyFavoriteSelected: (settingJson?: string, isDefault?: boolean) => void;
}

export function CaseEasyUpdateHeader(props: ICaseEasyUpdateHeaderProps) {
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    const userCanAddNewCase = Authorization.userHasRight(
        UserRightsEnum.AddNewCase,
        user,
        zoneContext.zoneGuid
    );

    const showSaveButton = props.addNewCase || props.changesDetected;

    return (
        <div className="row">
            <h1 className="col-sm-6 mb-0">
                {props.addNewCase ? (
                    'Add New Case - Easy Update'
                ) : (
                    <span style={{ display: 'flex', gap: 15, alignItems: 'center' }}>
                        <span style={{ whiteSpace: 'nowrap' }}>
                            {props.currentCase?.guid ? (
                                <CaseName
                                    caseGuid={props.currentCase?.guid}
                                    caseTitle={CaseHelper.getCaseTitle(props.currentCase)}
                                    openLinkInNewTab={true}
                                    additionalText={
                                        <>
                                            <span>-</span>
                                            <span>Easy Update</span>
                                        </>
                                    }
                                    zoneContext={zoneContext}
                                />
                            ) : (
                                'Easy Update'
                            )}
                        </span>
                        <span className="font-size-xs" style={{ display: 'block', paddingTop: 5 }}>
                            {props.additionalHeaderText}
                        </span>
                    </span>
                )}
            </h1>
            <div
                className="col-sm-6"
                style={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    alignItems: 'center',
                }}
            >
                {userCanAddNewCase && !props.currentCase?.guid && !props.addNewCase && (
                    <button className="btn-no-bg float-end " onClick={props.onAddNewCase}>
                        <span className="btn-green btn float-end btn-icon">
                            <i className="fal fa-lg fa-plus color-white" />
                        </span>
                    </button>
                )}
                {props.currentCase?.guid && props.onCancel && (
                    <button className="btn btn-blue float-end" onClick={props.onBack}>
                        Back
                    </button>
                )}
                <button className="btn btn-default float-end" onClick={props.onClear}>
                    Clear
                </button>
                {showSaveButton && (
                    <button
                        className="btn btn-orange float-end text-gray"
                        onClick={props.onSaveCase}
                    >
                        Save
                    </button>
                )}
                <Favorite
                    user={user}
                    type={{ id: FavoriteTypesEnum.EasyUpdate }}
                    currentFavoriteSettingJson={
                        (props.easyUpdateFieldsSelected?.length ?? 0) > 0
                            ? JSON.stringify(props.easyUpdateFieldsSelected)
                            : ''
                    }
                    currentFavoriteDetailsString={props.currentFavoriteDetailsString}
                    onFavoriteSelected={props.onFavoriteSelected}
                    applyFavoriteSelected={props.onApplyFavoriteSelected}
                    zoneContext={zoneContext}
                />
                <Link
                    className="float-end no-padding-bottom"
                    target="_blank"
                    to={`${LocalRoutes.ViewSpecificPDF.replace(
                        ':id',
                        TutorialTopics.EasyUpdate.toString()
                    )}`}
                >
                    <span className="btn btn-no-bg text-gray">
                        <i className={'fal fa-graduation-cap'} />
                        &nbsp;Tutorials
                    </span>
                </Link>
            </div>
        </div>
    );
}
